/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import FormField from 'apps/FormField'
import CheckboxElement from 'elements/Checkbox'

const Input: React.FC<any> = ({
  input,
  meta,
  ...restProps
}) => (
  <FormField>
    <CheckboxElement {...input} checked={input.value} {...restProps} />
  </FormField>
)

export default Input
